import { StringParam, useQueryParam } from 'use-query-params';

const useSharingPreviewStep = () => useQueryParam('step', StringParam);

export default useSharingPreviewStep;
